import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import Select from 'react-select';
import Skeleton from 'react-loading-skeleton';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWineBottle, faFilter, faFileExcel, faUser } from '@fortawesome/free-solid-svg-icons';
import BigNumberMetaContratante from 'components/relatorios/big-number-meta-contratante';
import lib from '../../helpers/lib';
import RelatorioService from 'services/relatorio-service';
import RepresentadaService from 'services/representada-service';
import DashboardService from 'services/dashboard-service';
import ProdutoService from 'services/produto-service';
import PedidoService from 'services/pedido-service';
import '../faturamento/styles.scss';

// { vendedores, representadas }
export default function FaturamentoCategorias() {
  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();

  const [isLoading, setIsLoading] = React.useState(true);

  const [metaEquipe, setMetaEquipe] = useState(null);
  const [categorias, setCategorias] = React.useState([]);
  const [totalCategorias, setTotalCategorias] = React.useState([]);

  const [filter, setFilter] = React.useState({
    mes: m + 1,
    ano: y,
    representadaId: null,
    vendedorId: null
  });

  const [representadas, setRepresentadas] = React.useState([]);
  const [vendedores, setVendedores] = React.useState([]);

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);

  useEffect(() => {
    (async () => {
      const firstRepresentada = await getSelectListRepresentada();
      
      await getSelectListVendedor();
  
      if (firstRepresentada) {
        setFilter({ ...filter, representadaId: firstRepresentada.value });
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (vendedores) {
        if (vendedores.length === 1) {
          setFilter((prevFilter) => ({
            ...prevFilter,
            vendedorId: vendedores[0]?.value
          }));
        }
        setLoadedVendedores(true);
      }
    })();
  }, [vendedores]);

  useEffect(() => {
    (async () => {
      if (representadas && representadas.length > 0) {
        setFilter((prevFilter) => ({
          ...prevFilter,
          representadaId: representadas[0]?.value
        }));

        setLoadedRepresentadas(true);
      }
    })();
  }, [representadas]);

  useEffect(() => {
    (async () => {
      if (loadedRepresentadas && loadedVendedores) {
        getFaturamentoCategorias();
        getCardsMensais();
      }
    })();
  }, [loadedRepresentadas, loadedVendedores]);

  useEffect(() => {
    (async () => {
      if (categorias.length > 0) {
        let catTotal = {
          nomeCategoria: ' ',
          valorFaturadoMesAnterior: +categorias
            .reduce((acc, item) => acc + item.valorFaturadoMesAnterior, 0)
            .toFixed(2),
          valorPedido: +categorias.reduce((acc, item) => acc + item.valorPedido, 0).toFixed(2),
          valorFaturado: +categorias.reduce((acc, item) => acc + item.valorFaturado, 0).toFixed(2),
          valorMeta: +categorias.reduce((acc, item) => acc + item.valorMeta, 0).toFixed(2)
        };

        catTotal.porcentagemValorPedido =
          catTotal.valorMeta != 0
            ? +((catTotal.valorPedido / catTotal.valorMeta) * 100).toFixed(2)
            : 0;
        catTotal.porcentagemValorFaturado =
          catTotal.valorMeta != 0
            ? +((catTotal.valorFaturado / catTotal.valorMeta) * 100).toFixed(2)
            : 0;

        setTotalCategorias([catTotal]);
      }
    })();
  }, [categorias]);

  async function getCardsMensais() {
    setMetaEquipe(null);

    let filterModel = {
      representadaId: filter.representadaId,
      mes: filter.mes,
      ano: filter.ano,
      vendedorId: filter.vendedorId
    };
    let response = await DashboardService.getCardsMensais(filterModel);

    response.data && setMetaEquipe(response.data.data);
  }

  async function getFaturamentoCategorias() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getFaturamentoCategorias(filter);
    if (resultStatus.data) {
      setCategorias(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getExtratoFaturamentoCategorias() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoFaturamentoCategorias(filter);

    if (response?.data) {
      let fileName = `faturamento_categorias_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  async function getSelectListRepresentada() {
    let representadas = await ProdutoService.selectListRepresentadasAsync();

    if (representadas.data) {
      setRepresentadas(representadas.data.data);
      return representadas.data.data[0];
    }
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();
    if (vendedores.data) setVendedores(vendedores.data.data); //([...[{}], ...representadas.data.data]);
  }

  return (
    <Layout>
      <PageTitleCard title="Análise Categorias" icon={<FontAwesomeIcon icon={faUser} />} />

      <div className="background-relatorio">
        {/* Filter ------------------------------------------------------------------------------ */}
        <div className="row filter-bar2 mb-4 mt-4">
          <div className="col-lg-2">
            <label>Representada</label>
            <Select
              isClearable={false}
              // clearValue={() => {
              //   setFilter({ ...filter, representadaId: null });
              // }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={representadas}
              value={representadas?.find((x) => x.value === filter.representadaId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, representadaId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Vendedor</label>
            <Select
              isClearable={vendedores?.length > 1}
              clearValue={() => {
                setFilter({ ...filter, vendedorId: null });
              }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores?.find((x) => x.value === filter.vendedorId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, vendedorId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Mês</label>
            <Select
              className="select-form-control"
              value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
              options={lib.selectListMeses}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, mes: item.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Ano</label>
            <Select
              className="select-form-control"
              value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
              options={lib.selectListAnos}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, ano: item.value });
              }}
            />
          </div>

          <div className="col row">
            <div className="col-xl-4"></div>

            <div className="col-xl-4 col-6 align-content-end">
              {/* Botão Exportar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                  });
                  getExtratoFaturamentoCategorias();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFileExcel} /> Exportar
              </button>
            </div>

            <div className="col-xl-4 col-6 align-content-end">
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                    //pageNumber: 1
                  });
                  getFaturamentoCategorias();
                  getCardsMensais();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFilter} /> Filtrar
              </button>
            </div>
          </div>
        </div>

        {/* <div className="col-lg-12 shadow p-3 mb-5 bg-white rounded border-radius: 150px"> */}
        <div>
          <BigNumberMetaContratante source={metaEquipe} />
        </div>

        {/* Lista Representadas ----------------------------------------------------------------- */}
        <div className="table-responsive table-historico mt-5" onCopy={(e) => lib.parseCopiedText(e)}>
          {!isLoading && categorias ? (
            <Table striped bordered hover width="100%" className="table-relatorio">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th>Fat Mês Anterior</th>
                  <th>Pedido</th>
                  {/* <th>Valor em Cateira (%)</th> */}
                  <th>Faturado</th>
                  <th>Objetivo</th>
                  <th style={{ textAlign: 'center' }}>% Pedido</th>
                  <th style={{ textAlign: 'center' }}>% Faturado</th>
                  {/* <th>% Faturado + Carteira</th> */}
                </tr>
              </thead>
              <tbody>
                {categorias.length > 0 ? (
                  ([...categorias, ...totalCategorias] || [])?.map((item, index) => (
                    <tr key={index} className={index >= categorias.length ? 'fw-700' : ''}>
                      <td>{item.nomeCategoria}</td>
                      <td>
                        <span>
                          {/* {item.valorFaturadoMesAnterior.toFixed(2)} */}
                          {Math.floor(item.valorFaturadoMesAnterior).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                            maximumFractionDigits: 0
                          })}
                        </span>
                      </td>
                      <td>
                        {/* {item.valorPedido.toFixed(2)} */}
                        {Math.floor(item.valorPedido).toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                          maximumFractionDigits: 0
                        })}
                      </td>
                      {/* <td>
                      {item.valorValorCarteira.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })}
                      <span> ({item.porcentagemValorCarteira}%)</span>
                    </td> */}
                      <td>
                        {/* {item.valorFaturado.toFixed(2)} */}
                        {Math.floor(item.valorFaturado).toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                          maximumFractionDigits: 0
                        })}
                      </td>
                      {/* <td>
                      {item.valorFaturadoECarteira.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })}
                      <span> ({item.porcentagemFaturadoECarteira}%)</span>
                    </td> */}
                      <td>
                        {/* {item.valorMeta.toFixed(2)} */}
                        {Math.floor(item.valorMeta).toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                          maximumFractionDigits: 0
                        })}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {lib.formatToNumeric(item.porcentagemValorPedido, 2, true)}%
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {lib.formatToNumeric(item.porcentagemValorFaturado, 2, true)}%
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Skeleton count={10} />
          )}
        </div>
      </div>
    </Layout>
  );
}
